export interface IRefund {
    paymentId: number;
    reasonId: number;
    note: string | null;
    refundType: RefundType;
    lastCardNum: number | string | null;
    payDate: string | null;
    bankName: string | null;
    inn: number | string | null;
    bik: number | string | null;
    corrBill: number | string | null;
    accBill: number | string | null;
    srvdepIds: string | null;
}

export interface IResponseGetRefundList {
    keyId: number;
    text: string;
}

export interface ISrvdep {
    keyId: number;
    text: string;
    amount?: number | string;
}

export enum RefundType {
    cash = 1,
    card = 2,
    requisits = 3,
}
